import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=6fff9fcd&"
import script from "./color-picker.vue?vue&type=script&lang=js&"
export * from "./color-picker.vue?vue&type=script&lang=js&"
import style0 from "./color-picker.vue?vue&type=style&index=0&id=6fff9fcd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports